import React from "react";

const AppLoader = () => {
  return (
    <>
      <style>
        {`
          .loader-container {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background-color: rgba(206, 206, 206, 0.7); /* optional: semi-transparent overlay */
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            z-index: 9999; /* make sure it's on top of everything */
          }

          .loader-spinner {
            width: 50px;
            height: 50px;
            border: 5px solid #e0e0e0;
            border-top-color: #5cd1d0;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
          }

          .loader-text {
            margin-top: 12px;
            font-size: 16px;
            font-weight: 500;
            color: #056363;
          }

          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>

      <div className="loader-container">
        <div className="loader-spinner"></div>
        <p className="loader-text">Loading...</p>
      </div>
    </>
  );
};

export default AppLoader;
